import { Flex, type FlexProps } from '@chakra-ui/react'
import ConfettiAnimation from 'commons/components/confetti/ConfettiAnimation'
import { BgColorsRaw, BrandColorsRaw } from 'commons/design-system/tokens'
import type { ReactNode } from 'react'

type Props = FlexProps & {
	children: ReactNode
	footer?: ReactNode
	withConfetti?: boolean
}

const PageLayout = ({ children, footer, withConfetti = false, ...props }: Props) => {
	return (
		<Flex direction='column' minH='100vh' w='full' alignSelf='stretch'>
			<Flex
				as='main'
				w='full'
				direction='column'
				alignItems='flex-end'
				mb={4}
				mt={{ base: '0', md: '80px' }}
				pb={{ base: '20px', md: '40px' }}
				flex='1'
				{...props}
			>
				{withConfetti && (
					<ConfettiAnimation
						colors={[BrandColorsRaw.PRIMARY, BrandColorsRaw.SECONDARY, BgColorsRaw.Z5]}
					/>
				)}
				{children}
			</Flex>
			{footer}
		</Flex>
	)
}

export default PageLayout
